import { I18n } from 'aws-amplify/utils';
import { Button, View, useAuthenticator } from '@aws-amplify/ui-react';
import { spaceCadet } from '@cogneed/react-utils';
import useSingleSignOnContext from './SingleSignOnContext';

export default function SignInFooter() {
  const { toForgotPassword } = useAuthenticator();
  const useSso = useSingleSignOnContext();
  return (
    <View as="div" padding={32} paddingTop={0} marginTop={-16}>
      <View textAlign="center" marginBottom={32}>
        <Button
          backgroundColor={spaceCadet[500]}
          isFullWidth
          fontWeight="normal"
          onClick={useSso}
          variation="primary"
        >
          {I18n.get('sso.title')}
        </Button>
      </View>
      <View textAlign="center" marginTop={32}>
        <Button
          fontWeight="normal"
          onClick={toForgotPassword}
          size="small"
          variation="link"
        >
          Reset Password
        </Button>
      </View>
    </View>
  );
}
